/**
 * Regroupe les resultats de la recherche globale par type, pour la palette.
 *
 * POURQUOI UN GROUPEMENT. Le serveur rend jusqu'a huit types a la suite. En
 * liste plate, un sinistre, un PV et un encaissement se succedent sans rien
 * qui separe les familles : l'agent lit huit lignes et doit deviner, ligne par
 * ligne, de quoi il s'agit. Un en-tete par type rend la lecture en un coup
 * d'oeil.
 *
 * POURQUOI `aplati` EXISTE, et c'est le coeur de ce module. La navigation
 * clavier compte des INDEX. Si l'ordre visuel (groupe) differe de la liste que
 * la surbrillance indexe, la fleche bas surligne une ligne et Entree en ouvre
 * une autre : defaut silencieux, plausible, et l'agent atterrit sur le mauvais
 * dossier. `aplati` est donc la liste dans l'ordre OU L'AGENT LES VOIT, seule
 * liste que la surbrillance a le droit d'indexer.
 *
 * L'ORDRE DES GROUPES EST CELUI DE LA PREMIERE APPARITION, jamais l'alphabet :
 * le serveur classe ses types par `@Order`, SINISTRE en tete parce que c'est
 * le plus cherche. Trier par nom ici defairait ce classement en silence.
 */

/** Type de repli pour un resultat arrive sans type : la reponse vient du reseau. */
const TYPE_INCONNU = 'AUTRE';

/**
 * @param resultats les resultats tels que le serveur les rend, ou null
 * @param options.maxParGroupe nombre maximum de lignes affichees par type.
 *   Omis, rien n'est tronque.
 * @returns `{ groupes: [{ type, resultats, tronque }], aplati }`
 */
export function groupesResultats(resultats, { maxParGroupe } = {}) {
  if (!Array.isArray(resultats) || resultats.length === 0) {
    return { groupes: [], aplati: [] };
  }

  // Map conserve l'ordre d'insertion : c'est ce qui preserve le classement du
  // serveur sans avoir a le retrier.
  const parType = new Map();
  resultats.forEach((resultat) => {
    const type = resultat?.type || TYPE_INCONNU;
    if (!parType.has(type)) parType.set(type, []);
    parType.get(type).push(resultat);
  });

  const groupes = [];
  const aplati = [];
  parType.forEach((lignes, type) => {
    const visibles = maxParGroupe ? lignes.slice(0, maxParGroupe) : lignes;
    groupes.push({ type, resultats: visibles, tronque: visibles.length < lignes.length });
    // Seules les lignes VISIBLES rejoignent `aplati` : sinon la fleche bas
    // descend sur une ligne absente de l'ecran, et Entree ouvre un dossier
    // que l'agent n'a jamais vu.
    aplati.push(...visibles);
  });

  return { groupes, aplati };
}
